import React, { useState } from "react";
import { EuiBadge } from "@elastic/eui";
import { TranslateLanguage } from "../components/KeywordTranslator";

export default function LanguageToggle() {
  const browserIsCN = (navigator.language || navigator.userLanguage) === "zh-CN";
  const initial = localStorage.userLanguage || (browserIsCN ? "S" : "T");
  const [language, setLanguage] = useState(initial);

  const toggle = () => {
    const next = language === "T" ? "S" : "T";
    setLanguage(next);
    localStorage.userLanguage = next;

    // 刷新但停留在当前页
    const same = location.pathname + location.search + location.hash;
    window.location.replace(same);
  };

  const label = language === "T" ? "繁體" : "简体";

  return (
    <EuiBadge
      color="hollow"
      iconType="globe"
      onClick={toggle}
      onClickAriaLabel={TranslateLanguage(language, "切換語言")}
      className="lang-badge"
    >
      {label}
    </EuiBadge>
  );
}
